/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer } from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';
import {
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';
import type { WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto } from './WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto';
import {
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto';

/**
 * A logged in member answers an event. Name and e-mail come from the member register.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto {
    /**
     * The unique id of the event.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto
     */
    eventUniqueId?: string | null;
    /**
     * Message to the organizer.
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto
     */
    answer?: string | null;
    /**
     * The answer for each time.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto
     */
    timeAnswers?: Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer> | null;
    /**
     * The people of the household that are signed up, each with own answers. Null when the member only
     * answers for themselves with WebApi.Services.DataTransferObjects.ReplyService.SaveMemberReplyDto.TimeAnswers.
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto
     */
    people?: Array<WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDto> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventUniqueId': !exists(json, 'eventUniqueId') ? undefined : json['eventUniqueId'],
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'timeAnswers': !exists(json, 'timeAnswers') ? undefined : (json['timeAnswers'] === null ? null : (json['timeAnswers'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON)),
        'people': !exists(json, 'people') ? undefined : (json['people'] === null ? null : (json['people'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceSaveMemberReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventUniqueId': value.eventUniqueId,
        'answer': value.answer,
        'timeAnswers': value.timeAnswers === undefined ? undefined : (value.timeAnswers === null ? null : (value.timeAnswers as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON)),
        'people': value.people === undefined ? undefined : (value.people === null ? null : (value.people as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceHouseholdPersonAnswerDtoToJSON)),
    };
}

